var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datepicker',{attrs:{"input-class":"form-control","language":_vm.hr,"format":_vm.customFormatter},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.selectedDateFormatted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }